import { render, staticRenderFns } from "./ListProductBrand.vue?vue&type=template&id=4b231e8d&"
import script from "./ListProductBrand.vue?vue&type=script&lang=ts&"
export * from "./ListProductBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b231e8d')) {
      api.createRecord('4b231e8d', component.options)
    } else {
      api.reload('4b231e8d', component.options)
    }
    module.hot.accept("./ListProductBrand.vue?vue&type=template&id=4b231e8d&", function () {
      api.rerender('4b231e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductBrand/ListProductBrand.vue"
export default component.exports